import { render, staticRenderFns } from "./CardInfoDetalhesPedido.vue?vue&type=template&id=0469350b&"
import script from "./CardInfoDetalhesPedido.vue?vue&type=script&lang=js&"
export * from "./CardInfoDetalhesPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports